<template>
    <div class="fixed z-index-fixed top-0 left-0 overflow-hidden duration-1000 ease-in-out"
         :class="SideMenuStore.state.active ? 'sidebar-open' : 'sidebar-close'"
         data-cy="container_side_menu_root">
        <div class="bg-black bg-opacity-70 w-screen h-screen fixed top-0 left-0"
             v-if="SideMenuStore.state.active"
             @click="closeMenu()"
             data-cy="btn_side_menu_backdrop"></div>
        <div class="w-60 h-screen bg-white relative" data-cy="container_side_menu_panel">
            <div class="text-green-600 font-main-light text-xl text-center p-3" data-cy="text_side_menu_title">Tailwind CSS</div>
            <router-link to="/home"
                    class="block border-t p-2"
                    :class="{'bg-gray-300' : pageActive == 'home'}"
                    data-cy="btn_side_menu_home">
                Home
            </router-link>
            <router-link to="/tailwind"
                    class="block border-t last:border-b p-2"
                    :class="{'bg-gray-300' : pageActive == 'tailwind'}"
                    data-cy="btn_side_menu_tailwind">
                Tailwind
            </router-link>
        </div>
    </div>
</template>
<script>

export default {
    name: "SideMenu",
    inject: ['SideMenuStore'],
    data: function() {
        return {
            pageActive: this.$route.name,
        };
    },
    watch:{
        $route: function() {
            this.closeMenu();
        },

        'SideMenuStore.state.active': function () {
            let active = this.SideMenuStore.state.active;
            console.log('side menu change', this.SideMenuStore.state.active);
            setTimeout(() => {
                if (active) {
                    document.body.classList.add('not-scroll');
                } else {
                    document.body.classList.remove('not-scroll');
                }
            }, 500);
        },
    },
    methods: {
        closeMenu: function() {
            this.SideMenuStore.methods.close();
        },
    },
}
</script>
<style lang="scss" scoped>
    .sidebar-open {
        width: 240px;
    }
    .sidebar-close {
        width: 0px;
    }
</style>
